module.exports = __webpack_public_path__ + "img/terroir-spiral-4-mobile.8a7841d1.jpg";